import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { babyShowerTestimonials } from '../../data/babyShowerTestimonials';
const reviewsCopy = {
  title: 'Las experiencias de quienes celebraron con nuestros juegos'
};

/** Alterna rosa y celeste en el detalle de cada tarjeta */
const tones = ['bg-[#FDE3EC] text-[#E74D7A]', 'bg-[#DDF2F1] text-[#15ADA8]'];
export function Reviews() {
  return <section aria-labelledby="reviews-title" className="bg-[#FBF6EE] py-11 md:py-16" data-id="element-314" data-mp="wqy4i9z1pxfn">
      <div className="mx-auto max-w-5xl px-5 sm:px-6" data-id="element-315" data-mp="rrbue9eikxb2">
        <h2 id="reviews-title" className="mx-auto max-w-[24ch] text-center font-display text-[1.65rem] font-extrabold leading-[1.15] tracking-[-0.02em] text-[#4A3A35] [text-wrap:balance] sm:text-[2.1rem] md:text-[2.4rem]" data-id="element-316" data-mp="rpqyafcjx6b3">
          {reviewsCopy.title}
        </h2>

        <ul className="mt-7 grid gap-3 md:mt-10 md:grid-cols-3 md:gap-4" data-id="element-317" data-mp="2h5qciav11lxl">
          {babyShowerTestimonials.map((t, i) => {
          const tone = tones[i % tones.length];
          const isPending = !t.quote;
          return <li key={i} className="flex flex-col rounded-3xl border border-[#EFE4D6] bg-white p-5 shadow-[0_10px_28px_-22px_rgba(139,107,85,0.45)] md:p-6" data-id="element-318" data-mp="1k9rowd6b72am" data-mpi={i}>
                <div className="flex items-center gap-3" data-id="element-319" data-mp="1abllfr4uto3n">
                  <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl ${tone}`} aria-hidden="true" data-id="element-320" data-mp="1ac3qnd9hvcnp">
                    <QuoteIcon className="h-4 w-4 fill-current" strokeWidth={1.5} data-id="element-321" data-mp="1y3ipux5z5duq" />
                  </span>
                  {!isPending && t.title && <h3 className="font-display text-[18px] font-extrabold leading-snug text-[#4A3A35]" data-id="element-322" data-mp="1oalerc3bar65">{t.title}</h3>}
                </div>

                {isPending ? <>
                    <p className="mt-4 rounded-xl border-2 border-dashed border-[#E3CFC0] bg-[#FDF9F3] px-3 py-4 text-center text-[13px] font-bold uppercase tracking-[0.06em] text-[#8B6B55]" data-id="element-323" data-mp="2gypktypsp69d">
                      [Testimonio real pendiente]
                    </p>
                    <p className="mt-auto pt-4 text-[13px] leading-snug text-body" data-id="element-324" data-mp="2qneedbbjmlys">
                      Reemplazar por la opinión auténtica de una clienta antes de publicar.
                    </p>
                  </> : <>
                    <blockquote className="mt-3 text-[16px] italic leading-relaxed text-body" data-id="element-325" data-mp="2cnv52f6zx4kw">“{t.quote}”</blockquote>
                    <footer className="mt-auto pt-4" data-id="element-326" data-mp="27wmx7nlbdr9u">
                      <div className="mb-3 h-px w-full bg-[#F3EAE0]" aria-hidden="true" data-id="element-327" data-mp="27vtv4zxavpy1" />
                      <p className="font-display text-[15px] font-bold text-[#4A3A35]" data-id="element-328" data-mp="22ylgvaf9w622">{t.name}</p>
                      {t.detail && <p className="text-[13px] text-body" data-id="element-329" data-mp="1yudngzxve1xi">{t.detail}</p>}
                    </footer>
                  </>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}